import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import DOMPurify from "dompurify";

export default function InboxTab({ fromDate, toDate }) {
  const [messages, setMessages] = useState([]);
  const [dairy, setDairy] = useState(null);
  const [loading, setLoading] = useState(false);
  const API_BASE = process.env.REACT_APP_API_URL;
  const farmerUsername = localStorage.getItem("farmerUsername") || "F-B-3";

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        // const res = await fetch(`${API_BASE}/getTransactions`, {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify({
        //     username: farmerUsername,
        //     from_date: fromDate,
        //     to_date: toDate,
        //     transaction_type: "null",      // 🔹 always send trantype as "null"
        //     group_by_type: false,  // 🔹 default
        //   }),
        // });

        const res = await fetch(`${API_BASE}/getTransactions`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            username: farmerUsername,
            from_date: fromDate,
            to_date: toDate,
            trantype: "null",      // 🔹 always send trantype as "null"
            group_by_type: false,
          }),
        });

        if (!res.ok) throw new Error("Failed to fetch");

        const data = await res.json();
        console.log("Fetched transactions:", data);
        setDairy(data.dairy || null);
        setMessages(data.transactions || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [fromDate, toDate, farmerUsername]);

  // 🔹 Format date to DD/MM/YYYY
  const formatDate = (dateStr) => {
    try {
      const d = new Date(dateStr);
      return d.toLocaleDateString("en-GB"); // 01/08/2025
    } catch {
      return dateStr;
    }
  };

  const fmt = (val, digits = 2) => {
    const num = Number(val);
    return isNaN(num) ? "0.00" : num.toFixed(digits);
  };

  const renderMessage = (msg, index) => {
    const dairyName = dairy?.companyname || "डेअरी";

    if (msg.trantype === "COLLECTION") {
      return (
        <Box key={index} sx={{ mb: 2, p: 2, bgcolor: "#fff", borderRadius: 2, boxShadow: 1 }}>
          <Typography fontWeight="bold">{dairyName}</Typography>
          <Typography>दि. {formatDate(msg.tran_date)} {msg.shift_code === "1" ? "सकाळ" : "सायं"}</Typography>
          <Typography>{msg.milktypecode === "1" ? "गाय" : "म्हैस"} लिटर्स : {fmt(msg.qty, 3)}</Typography>
          <Typography>Fat : {fmt(msg.fat, 1)} Snf : {fmt(msg.snf, 1)}</Typography>
          <Typography>
            दर रु. {fmt(msg.rate)} रु. {fmt(msg.amount)}
          </Typography>
        </Box>
      );
    }

    // if (msg.trantype === "ADV-NAVE") {
    //   return (
    //     <Box key={index} sx={{ mb: 2, p: 2, bgcolor: "#fff", borderRadius: 2, boxShadow: 1 }}>
    //       <Typography fontWeight="bold">{dairyName}</Typography>
    //       <Typography>
    //         दि. {formatDate(msg.tran_date)} रोजी रु.{fmt(msg.amount, 0)} तुमचे अडवांस खात्यावर नावे करण्यात आले आहेत.
    //       </Typography>
    //       <Typography>
    //         आज अखेर तुमचे येणे बाकी रु.{fmt(msg.balance)} आहे.
    //       </Typography>
    //     </Box>
    //   );
    // }

    // if (msg.trantype === "ADV-JAMA") {
    //   return (
    //     <Box key={index} sx={{ mb: 2, p: 2, bgcolor: "#fff", borderRadius: 2, boxShadow: 1 }}>
    //       <Typography fontWeight="bold">{dairyName}</Typography>
    //       <Typography>
    //         दि. {formatDate(msg.tran_date)} रोजी रु.{fmt(msg.amount, 0)} तुमचे अडवांस खात्यावर जमा करण्यात आले आहेत.
    //       </Typography>
    //       <Typography>
    //         आज अखेर तुमचे येणे बाकी रु.{fmt(msg.balance)} आहे.
    //       </Typography>
    //     </Box>
    //   );
    // }

    // if (msg.trantype === "CFD-GVN") {
    //   return (
    //     <Box key={index} sx={{ mb: 2, p: 2, bgcolor: "#fff", borderRadius: 2, boxShadow: 1 }}>
    //       <Typography fontWeight="bold">{dairyName}</Typography>
    //       <Typography>
    //         दि. {formatDate(msg.tran_date)} रोजी रु.{fmt(msg.dramt, 0)} तुमचे खाद्य खात्यावर नावे करण्यात आले आहेत.
    //       </Typography>
    //       <Typography>
    //         आज अखेर तुमचे येणे बाकी रु.{fmt(msg.balance)} आहे.
    //       </Typography>
    //     </Box>
    //   );
    // }

    // if (msg.trantype === "CFD-RCD") {
    //   return (
    //     <Box key={index} sx={{ mb: 2, p: 2, bgcolor: "#fff", borderRadius: 2, boxShadow: 1 }}>
    //       <Typography fontWeight="bold">{dairyName}</Typography>
    //       <Typography>
    //         दि. {formatDate(msg.tran_date)} रोजी रु.{fmt(msg.cramt, 0)} तुमचे खाद्य खात्यावर जमा करण्यात आले आहेत.
    //       </Typography>
    //       <Typography>
    //         आज अखेर तुमचे येणे बाकी रु.{fmt(msg.balance)} आहे.
    //       </Typography>
    //     </Box>
    //   );
    // }

    // if (msg.trantype && msg.trantype.toUpperCase().includes("SMS")) {
    //   const safeHTML = DOMPurify.sanitize(msg.remark);
    //   return (
    //     <Typography
    //       variant="body2"
    //       component="div"
    //       dangerouslySetInnerHTML={{ __html: safeHTML }}
    //     />
    //   );
    // }    
    // // fallback
    // return (
    //   <Box key={index} sx={{ mb: 2, p: 2, bgcolor: "#fff", borderRadius: 2, boxShadow: 1 }}>
    //     <Typography fontWeight="bold">{dairyName}</Typography>
    //     <Typography>
    //       दि. {formatDate(msg.tran_date)} - {msg.trantype} ₹{fmt(msg.amount)}
    //     </Typography>
    //   </Box>
    // );
  };

  return (
    <Box sx={{ maxHeight: "70vh", overflowY: "auto", pr: 1, bgcolor: "#ece5dd" }}>
      {loading ? (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : messages.length ? (
        messages.map(renderMessage)
      ) : (
        <Typography
          variant="body1"
          sx={{ textAlign: "center", mt: 4, color: "text.secondary" }}
        >
          {/* कोणतेही रेकॉर्ड आढळले नाहीत */}
        </Typography>
      )}
    </Box>
  );
}
